<template>
  <div
    class="switch-version-box"
    v-if="showSwitchVersionOfficialTopupNew"
    @click="switchVersionOfficialTopupNew"
  >
    <a href="javascript:;" class="switch-version-btn" :class="gameCode">
      <div class="switch-version-btn-text" :class="[lang]">
        <p>{{ letter.switchNewVersion }}</p>
        <p>{{ letter.switchNewVersionPlatform }}</p>
      </div>
    </a>
  </div>
</template>

<script>
import switchVersion from '@mixins/officialTopup/switchVersion';
import { mapState } from 'vuex';
export default {
  mixins: [switchVersion],
  name: 'SwitchVersion',
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      lang: state => state.lang,
      letter: state => state.letter
    }),
    gameCode() {
      return `game-${this.gameId}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopup/_dimen.scss';
.switch-version-box {
  position: fixed;
  z-index: 10;
  height: 50px;
  right: 0;
  top: 520px;
}

.switch-version-btn {
  float: right;
  width: 168px;
  height: 204px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  cursor: pointer;

  &.game-390 {
    background-image: url($mugloImg + 'm-switch-version.png');
  }

  &.game-429 {
    background-image: url($looteuImg + 'm-switch-version.png');
  }

  &-text {
    margin-top: 98px;
    text-align: center;
    user-select: none;
    &.vi-VN,
    &.it-IT {
      margin-top: 86px;
    }
    &.zh-CN,
    &.zh-TW {
      margin-top: 106px;
    }
    &.pt-PT {
      margin-top: 88px;
    }
    p {
      display: block;
      font-size: 22px;
      line-height: 20px;
      padding: 0 8px;
      // 文字渐变色
      font-weight: bold;
      -webkit-background-clip: text;
      color: transparent; /* Fallback for non-webkit browsers */
      background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: linear-gradient(to bottom, #ffe070, #ffffff);
      &:nth-child(1) {
        margin-bottom: 8px;
      }
    }
  }
}

@media screen and (orientation: landscape) {
  .switch-version-box {
    top: 440px;
  }
}
</style>
